export default __webpack_public_path__ + "static/media/sunil.3c9f4e77.jpg";